import api from '../config/api';
import { API_ENDPOINTS } from '../config/constants';

export const rentalService = {
  // Create a new rental (multipart with images)
  create: async (data, images = []) => {
    const formData = new FormData();
    formData.append('title', data.title);
    formData.append('description', data.description || '');
    formData.append('vacancies', data.vacancies);
    formData.append('rent_per_month', data.rent_per_month);
    formData.append('whatsapp_number', data.whatsapp_number);
    images.forEach((img) => formData.append('images', img));

    const response = await api.post(API_ENDPOINTS.RENTALS.CREATE, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Get all public listings
  list: async (params = {}) => {
    const response = await api.get(API_ENDPOINTS.RENTALS.LIST, { params });
    return response.data;
  },

  // Get seller's own listings
  myListings: async () => {
    const response = await api.get(API_ENDPOINTS.RENTALS.MY);
    return response.data;
  },

  // Get single rental by ID
  getById: async (id) => {
    const response = await api.get(API_ENDPOINTS.RENTALS.GET(id));
    return response.data;
  },

  // Delete a rental
  delete: async (id) => {
    const response = await api.delete(API_ENDPOINTS.RENTALS.DELETE(id));
    return response.data;
  },
};

export default rentalService;
